<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

	<div class="">
      <el-form inline ref="form" :model="searchform">
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value3" placeholder="구분" size="mini"  style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value2" placeholder="상태선택" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value4" placeholder="상태선택" size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions4"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
             <el-input placeholder="1착" v-model="searchform.keyword1" size="mini" style="width:50px" ></el-input>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
             <el-input placeholder="2착" v-model="searchform.keyword2" size="mini" style="width:50px" ></el-input>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
             <el-input placeholder="3착" v-model="searchform.keyword3" size="mini" style="width:50px" ></el-input>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" placeholder="타이틀선택" size="mini" style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input placeholder="키워드" v-model="searchform.keyword" size="mini" style="width:120px" ></el-input>
          </el-form-item>
           <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
                </el-date-picker>
          </el-form-item>
         
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">검색</el-button>  
          </el-form-item>
      </el-form>
       
     
    
      
        
    </div>
	<div class="d-flex align-items-center mt-2">
		
		<el-button type="danger" size="mini" @click="deleteAll">선택환불</el-button>
   <div class="text-muted ml-2"><span class="text-danger mr-2">경기전:{{formatMoney(buy_good0)}}</span>|<span class="text-primary ml-2 mr-2">전금액:{{formatMoney(buy_good0_sum)}}</span>|<span class="text-info ml-2 mr-2">배팅:{{formatMoney(total_money)}}</span>|<span class="text-success ml-2 mr-2">적중:{{formatMoney(total_emoney)}}</span>|<span class="text-danger ml-2">차액:{{formatMoney(minus)}}</span></div>
		
	
	</div>
   
  
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       empty-text="데이타가 없습니다" @selection-change="handleSelectionChange" @row-click="rowClick"  :highlight-current-row="true">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
    <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
       
       <el-table-column
        label="아이디" prop="buy_id" align="center" >
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
             <span @click="openModel(scope.row.buy_id)" class="text-primary" style="cursor:pointer">{{scope.row.buy_id}}</span> {{scope.row.buy_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
           </div>
          </template>
      </el-table-column> 

    

          
      <el-table-column
        
        label="장소" prop="buy_jangso" align="center">
         <template slot-scope="scope">
        {{jsarr[scope.row.buy_jangso]}}-{{scope.row.buy_num}}
      </template>
      </el-table-column>

       


      <el-table-column
        
        label="승식" prop="buy_gubun" align="center">
       
        <template slot-scope="scope">
        
       {{gubunObj[scope.row.buy_gubun]}} 
       
        </template>

      </el-table-column>

      <el-table-column
        
        label="배팅번호" prop="buy_gubun" align="center">
       
        <template slot-scope="scope">
        
       {{scope.row.buy_race1}} - {{scope.row.buy_race2}} - {{scope.row.buy_race3}}  
       
        </template>

      </el-table-column>
      


       <el-table-column
        
        label="배팅금액" prop="buy_money" align="center">
        <template slot-scope="scope"><span :class="scope.row.buy_cash>0 ?'text-danger' :'text-primary'">{{  formatMoney(scope.row.buy_money)}}</span></template>

      </el-table-column>

    

       <el-table-column
        
        label="배당" prop="buy_bedang" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_bedang)}}</template>

      </el-table-column>


       <el-table-column
        
        label="당첨금액" prop="buy_emoney" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_emoney)}}</template>

      </el-table-column>
     
      <el-table-column
        
        label="상태" prop="buy_good" align="center" width="100">
         <template slot-scope="scope">
          <span v-if="scope.row.buy_good === '0'" class="text-primary">경기전</span>
          <span v-if="scope.row.buy_good === '1'" class="text-danger">적중</span>
          <span v-if="scope.row.buy_good === '2'">비적중</span>
          <span v-if="scope.row.buy_good === '5'" class="text-success">환불</span>

        </template>
      </el-table-column>

     


     
     
      
       <el-table-column
        
        label="경주/배팅" prop="buy_time" align="center">
        <template slot-scope="scope">{{ scope.row.end_time.substring(11,16)}} / {{ scope.row.buy_time.substring(11,19)}}</template>
      </el-table-column>


     
       
       <el-table-column
        
        label="게임/이전" prop="ocs" align="right" width="150">
        <template slot-scope="scope">
        
          {{ formatMoney(scope.row.buy_cash)}} <span style="margin:0 5px">/</span>{{ formatMoney(scope.row.ocs)}}
          
        </template>
      </el-table-column>

       <el-table-column
        
        label="이벤/이전" prop="c_m" align="right">
        <template slot-scope="scope">{{ formatMoney(scope.row.buy_eventcash)}} <span style="margin:0 5px">/</span> {{ formatMoney(scope.row.oeventcs)}}</template>
      </el-table-column>
       
      
      
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[50, 70, 100,]"
					  :page-size="size"
					  layout="sizes,prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
          
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';

    export default {
     components: {
      layer
    },
    	data(){
    		return{
           getIndex:"",
           level_title:{
              '-2':'블랙',
              '-1':'대기',
              '0':'기본'             
            },
          raceData:[],
          gubunObj:{
            '0':'복승',
            '1':'쌍승',
            '2':'복연승',
            '3':'삼복승',
            '4':'삼쌍승',
          },
           raceObj:{
            '1':':한국경마',
            '4':'일본경마',
            '5':'일본경륜',
            '6':'일본경정',
            '8':'중앙경마',
          },
          jsarr:new Array("", "부산", "과천", "제주", "광명", "창원", "미사리", "부산(경륜)", "나고야", "미즈사와", "사가", "삿포로", "소노다", "아라오", "오비히로", "우라와", "카나자와", "코치", "후쿠야마", "후나바시", "카와사키", "아사히카와", "카사마츠", "오오이", "모리오카", "몬베츠", "히메지", "이와키", "벳푸", "가와사키", "마에바시", "오미야", "무코마치", "다카마쓰", "게이오카쿠", "이토", "도야마","키시와다", "마츠야마", "오구라","히라츠카","사세보","마츠도","오가키","나고야","마쓰사카","구루메","도요하시","와카야마","히로시마","오다와라","시즈오카","기후","나라","다치카와","욧카이치","세이부엔","후쿠이","우츠노미야","다케오", "에도가와", "스미노에", "헤이와지마", "하마나코", "아마가사키", "나루토", "다마가와", "마루가메", "토다", "기류","가마고오리","","","","","","","","","","한신", "나카야마", "쥬쿄","오구라","도쿄","니가타","삿포로","후쿠시마","하코다테"),
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
          formLoading:false,
          idDialogVisible: false,
    		  buy_good0:'',
          buy_good0_sum:'',
          total_emoney:'',
          total_money:'',
    			options: [{
	              label: '대기',
	              value: '1',
	             
	            }, {
	              label: '처리중',
	               value: '2',
	              
	            }, {
	              label: '완료',
	               value: '3',
	             
	            }, {
	              label: '취소',
	               value: '4',
	             
	            }], 
    			searchform:{
            time:[],
    				keyword:'',
    				keyword1:'',
            keyword2:'',
            keyword3:'',
    				searchOptions:[
                
    				{
		        	label:'구매자',
		        	value:'mem_name'
		        },
		        {
		        	label:'아이디',
		        	value:'mem_id'
		        },
		        {
		        	label:'경주',
		        	value:'buy_num'
		        }
		       

		        ],
		        searchOptions2:[
                
    				{
		        	label:'전체',
		        	value:''
		        },{
		        	label:'적중',
		        	value:'1'
		        },
		        
		        {
		        	label:'비적중',
		        	value:'2'
		        },
		        {
		        	label:'경기전',
		        	value:'0'
		        },
		      	{
		        	label:'환불',
		        	value:'5'
		        },
		        ],
            searchOptions3:[
            {
              label:'전체',
              value:''
            },
           
            ],
              searchOptions4:[
                
            {
              label:'전체',
              value:''
            },
            {
              label:'복승',
              value:'0'
            },
            {
              label:'쌍승',
              value:'1'
            },
            {
              label:'복연승',
              value:'2'
            },
            {
              label:'삼복승',
              value:'3'
            },
           {
              label:'삼쌍승',
              value:'4'
            },

            ],
		        value:'',
		        value2:'',
            value3:'',
            value4:'',



    			},
    			
         pickerOptions: {
          },
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        valueOption:'아이디',
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
    	
    	methods:{
        
        rowClick (row) {

          //console.log(row)

          this.getIndex=row.index
        },
          // 关闭弹框（头部的X）
        
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	 this.$message('검색타이틀 선택하세요');
                	 return;
                }
                this.currentPage=1;
                this.getList();             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       openModel(id){
        let pix=window.screen.width;
        let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
        
        });
        },
       // 批量删除
      deleteAll(){
        this.$confirm('환불하시겠습니까?', '알림', {
          confirmButtonText: '환불',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.buy_idx);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                      data:newids,
                      url:this.domain+'/admin/buy_up',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
    		getList(){

    		   
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/buylist?limit='+this.size+'&buy1='+this.searchform.keyword1+'&buy2='+this.searchform.keyword2+'&buy3='+this.searchform.keyword3+'&buy_gubun='+this.searchform.value4+'&buy_jangso='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('data=',response.data.raceaddr)

                    let newids=[];
                     response.data.raceaddr.forEach(item=>{
                      let obj={};
                      obj.label=item.type+'-'+item.name
                      obj.value=item.id
              
                      newids.push(obj);

                      console.log('obj',obj);
                     });


                this.searchform.searchOptions3=newids


                     let data = response.data.data
                     this.tableData =data.data
                   //  this.raceData = response.data.raceaddr
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.buy_good0 = response.data.buy_good0
                     this.buy_good0_sum = response.data.buy_good0_sum
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
               this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
    	 goodUp(e,v){

           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/admin/good_up',
                  data:{
                    id:e.row.id,
                    good:v
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },

            }).then((response) =>{ 
              console.log(response)
              if(response.data.code==200)
                      {
                         this.$message({
                          message:'완료',
                          type: 'success'
                        });

     
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }


               
            }).catch((error) =>{
             
             console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
/deep/ .el-table__body tr.current-row>td.el-table__cell {
   
    background-color: #f3eba3!important;
}

</style>


// WEBPACK FOOTER //
// src/views/buy/list.vue